import { render, staticRenderFns } from "./content_goods.vue?vue&type=template&id=942fe9ea&"
import script from "./content_goods.vue?vue&type=script&lang=ts&"
export * from "./content_goods.vue?vue&type=script&lang=ts&"
import style0 from "./content_goods.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports